import React from "react";
import { IconButton } from "material-ui";
import Delete from "material-ui/svg-icons/action/delete";
import Dropboxed from "material-ui/svg-icons/content/move-to-inbox";
import Invoiced from "material-ui/svg-icons/editor/monetization-on";
import Drafted from "material-ui/svg-icons/communication/email";
import Booked from "material-ui/svg-icons/notification/confirmation-number";
import Cancelled from "material-ui/svg-icons/content/block";
import ExpandMore from "material-ui/svg-icons/navigation/expand-more";
import ExpandLess from "material-ui/svg-icons/navigation/expand-less";
import Copy from "material-ui/svg-icons/content/content-copy";
import { commitMutation, graphql } from "react-relay";
import PropTypes from "prop-types";

import environment from "../../relay/environment";
import SegmentDetails from "./SegmentDetails";
import OurismanTravelTheme from "../../ourismanTravelTheme";

export default class SegmentListItem extends React.Component {
  static propTypes = {
    segment: PropTypes.shape().isRequired,
    trip: PropTypes.shape().isRequired,
    index: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      expanded: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const {
      segment: { id: oldId }
    } = this.props;
    const {
      segment: { id: newId }
    } = nextProps;

    if (oldId !== newId) {
      this.setState({ expanded: false });
    }
  }

  remove = () => {
    const {
      segment: { id: segmentId },
      trip: { id: tripId }
    } = this.props;

    if (confirm("Are you sure you want to delete this segment?")) {
      commitMutation(environment, {
        mutation: graphql`
          mutation SegmentListItem_DeleteSegment_Mutation(
            $input: DeleteSegmentInput!
          ) {
            deleteSegment(input: $input) {
              trip {
                numSegments
                segments {
                  id
                }
              }
            }
          }
        `,
        variables: { input: { tripId, segmentId } },
        onError: err => alert(err)
      });
    }
  };

  toggleExpanded = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  duplicateSegment = () => {
    const {
      segment: { id: segmentId }
    } = this.props;

    commitMutation(environment, {
      mutation: graphql`
        mutation SegmentListItem_DuplicateSegment_Mutation(
          $input: DuplicateSegmentInput!
        ) {
          duplicateSegment(input: $input) {
            trip {
              segments {
                id
                vendor {
                  id
                  name
                  amenityPrograms
                }
                trip {
                  id
                  searchId
                  numSegments
                  dropbox
                  invoice
                  draftVip
                  book
                  cancel
                }
                name
                dateString
                startDate
                endDate
                category
                bedType
                amenityProgram
                numAdults
                numChildren
                smokingRoom
                rates
                currency
                averageDailyRate
                cancellationDeadline
                dropbox
                invoiced
                vipDrafted
                booked
                cancelled
                sabreLocator
                confirmationNumber
                cancellationNumber
                vipLetter
                notes {
                  id
                  owner {
                    id
                    firstName
                  }
                  content
                  created
                }
              }
            }
          }
        }
      `,
      variables: { input: { segmentId } },
      onError: err => alert(err)
    });
  };

  render() {
    const { segment, index } = this.props;
    const {
      vendor,
      dateString,
      dropbox,
      invoiced,
      booked,
      cancelled,
      vipDrafted
    } = segment;
    const { expanded } = this.state;
    const vendorName = vendor === null ? "TBD" : vendor.name;

    const cancelledIconColor = OurismanTravelTheme.palette.accent1Color;
    let tripDataStyle = styles.tripDataStyle;
    if (cancelled) {
      tripDataStyle = {
        ...tripDataStyle,
        color: cancelledIconColor,
        textDecoration: "line-through"
      };
    }

    const needsDB = (booked && !dropbox) || (cancelled && dropbox);
    const needsInvoice = (booked && !invoiced) || (cancelled && invoiced);
    const needsDraft = (booked && !vipDrafted) || (cancelled && vipDrafted);

    const preventDelete =
      booked || cancelled || needsDB || needsInvoice || needsDraft;

    const listSummaryStyle = {
      ...styles.listSummaryStyle,
      background:
        index % 2 !== 0 ? OurismanTravelTheme.palette.primary3Color : ""
    };

    const ExpandButton = expanded ? ExpandLess : ExpandMore;

    return (
      <li style={styles.listItemStyle}>
        <div style={listSummaryStyle}>
          <div style={tripDataStyle} onTouchTap={this.toggleExpanded}>
            <span style={styles.segmentVendorStyle}>{vendorName}</span>
            <span style={styles.segmentDateStyle}>{dateString}</span>
          </div>
          <div style={styles.segmentIconStyle} onTouchTap={this.toggleExpanded}>
            <span style={{ width: 18, paddingRight: 2, paddingLeft: 2 }}>
              {(cancelled && <Cancelled />) || (!booked && <Booked />) || null}
            </span>
            <span style={{ width: 18, paddingRight: 2, paddingLeft: 2 }}>
              {needsDB ? (
                <Dropboxed color={cancelled ? cancelledIconColor : null} />
              ) : null}
            </span>
            <span style={{ width: 18, paddingRight: 2, paddingLeft: 2 }}>
              {needsInvoice ? (
                <Invoiced color={cancelled ? cancelledIconColor : null} />
              ) : null}
            </span>
            <span style={{ width: 18, paddingRight: 2, paddingLeft: 2 }}>
              {needsDraft ? (
                <Drafted color={cancelled ? cancelledIconColor : null} />
              ) : null}
            </span>
          </div>
          <div style={styles.listActionStyle}>
            <IconButton
              style={styles.buttonStyle}
              onTouchTap={this.toggleExpanded}
              tooltip={
                expanded ? "Hide Segment Details" : "View Segment Details"
              }
              tooltipPosition="bottom-left"
            >
              <ExpandButton />
            </IconButton>
            <IconButton
              style={styles.buttonStyle}
              onTouchTap={this.duplicateSegment}
              tooltip="Duplicate Segment"
              tooltipPosition="bottom-left"
            >
              <Copy />
            </IconButton>
            <IconButton
              style={styles.buttonStyle}
              onTouchTap={this.remove}
              disabled={preventDelete}
              tooltip="Delete Segment"
              tooltipPosition="bottom-left"
            >
              <Delete />
            </IconButton>
          </div>
        </div>
        <div>
          {expanded ? (
            <SegmentDetails
              segment={segment}
              onComplete={this.toggleExpanded}
            />
          ) : null}
        </div>
      </li>
    );
  }
}

const styles = {
  buttonStyle: {
    padding: 0,
    margin: "0px 4px 0px 4px",
    width: 20,
    height: 5
  },
  listItemStyle: {
    display: "flex",
    flexDirection: "column"
  },
  listSummaryStyle: {
    display: "flex",
    alignItems: "baseline",
    width: "100%",
    justifyContent: "space-between"
  },
  tripDataStyle: {
    flex: "2 1 50%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between"
  },
  segmentVendorStyle: {
    flex: "2 1 content"
  },
  segmentDateStyle: {
    flex: "0 0 content"
  },
  segmentIconStyle: {
    flex: "1 0 45%",
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline"
  },
  listActionStyle: {
    flex: "1 0 5%",
    display: "flex"
  },
  primaryTravelerStyle: {
    color: "grey",
    fontSize: 8,
    paddingLeft: 8
  }
};



// WEBPACK FOOTER //
// /src/components/Trips/SegmentListItem.js